export default Object.freeze({
  theme: 'theme',
  brandSettings: 'brandSettings',
  brand_settings: 'brand_settings',
  breakpoints: 'breakpoints'
});